// Deduplicate only when both the displayed name and the actual file match.
// An absent image cannot be proven identical to another absent image.
export const dedupeSelectablePictograms = (pictograms) => {
  const hashesByFile = new Map(pictograms.filter(p => p.icon_file_id && p.icon_sha256)
    .map(p => [p.icon_file_id, p.icon_sha256.toLowerCase()]));
  const result = [];
  const byIdentity = new Map();
  for (const picto of pictograms) {
    const file = picto.icon_file_id;
    const digest = file && (hashesByFile.get(file) || picto.icon_sha256?.toLowerCase());
    const image = digest ? `sha:${digest}` : file ? `file:${file}` : null;
    const identity = image ? JSON.stringify([picto.name, image]) : null;
    const index = identity && byIdentity.get(identity);
    if (index === undefined || index === null) {
      if (identity) byIdentity.set(identity, result.length);
      result.push({ ...picto, equivalent_ids: [picto.id] });
    } else {
      const existing = result[index];
      const preferred = picto.is_default && !existing.is_default ? picto : existing;
      result[index] = { ...preferred, equivalent_ids: [...existing.equivalent_ids, picto.id] };
    }
  }
  return result;
};

export const isPictogramSelected = (selectedIds, pictogram) =>
  (pictogram.equivalent_ids || [pictogram.id]).some(id => selectedIds.includes(id));

export const togglePictogramSelection = (selectedIds, pictogram) => {
  const equivalents = pictogram.equivalent_ids || [pictogram.id];
  return isPictogramSelected(selectedIds, pictogram)
    ? selectedIds.filter(id => !equivalents.includes(id))
    : [...selectedIds, pictogram.id];
};